import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TYPE_META } from "@/components/delivery/destinationConstants";
import { INPUT } from "@/components/pageSettings/AdminModal";
import { Field } from "./StepShell";

function summary(b) {
  const where = b.states ? `${b.states} state${b.states === 1 ? "" : "s"}` : "no states picked yet";
  const parts = [`their lead criteria (${where}${b.price ? `, $${b.price} a lead` : ""})`,
    `${b.shared_pages} shared page${b.shared_pages === 1 ? "" : "s"}`];
  if (b.own_pages) parts.push(`${b.own_pages} own page${b.own_pages === 1 ? "" : "s"} as drafts with the new name`);
  if (b.delivery_type) parts.push(`their ${TYPE_META[b.delivery_type]?.label || b.delivery_type} delivery settings`);
  return `Copies ${parts.join(", ")}.${b.delivery_type ? " You enter the new firm's own address and keys." : ""}`;
}

export function CopyFromBuyer({ value, onChange }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/buyer-setup/copy-sources").then((r) => setRows(r.data.buyers)).catch(() => setRows([]));
  }, []);
  const pick = (rows || []).find((r) => r.org_id === value);
  return (
    <div className="border-2 border-black bg-zinc-50 p-3 space-y-2" data-testid="setup-copy-from">
      <Field label="Start from an existing buyer (optional)">
        <select className={INPUT} value={value} onChange={(e) => onChange(e.target.value)} disabled={!rows}
                data-testid="setup-copy-from-select">
          <option value="">{rows ? "Start blank" : "Loading buyers…"}</option>
          {(rows || []).map((r) => <option key={r.org_id} value={r.org_id}>{r.name}{r.live ? "" : " (not live)"}</option>)}
        </select>
      </Field>
      <p className={`text-[11px] leading-relaxed ${pick ? "text-black" : "text-zinc-500"}`} data-testid="setup-copy-summary">
        {pick ? summary(pick) : "Pick a similar buyer to fill in their criteria, pages and delivery settings. You only check them."}
      </p>
    </div>
  );
}
